import { ComponentPublicInstance, getCurrentInstance } from 'vue';
import BuefyNamespace from 'buefy';

// "Temporary workaround" extracted from /apps/ens/helpers.ts
export default function useBuefy() {
    const self = getCurrentInstance();
    return (self!.proxy! as ComponentPublicInstance & { $buefy: typeof BuefyNamespace }).$buefy!;
}
